import React, { useEffect, useState } from "react";
import "../../Style/LandingPage/PopularDestination.css";
import { useNavigate, Link } from "react-router-dom"; // <-- Add Link here
import axios from "axios";

const PopularDestination = () => {
  const navigate = useNavigate();
  const [popularDestination, setPopularDestination] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [allTrips, setAllTrips] = useState([]);
  const [categoryStats, setCategoryStats] = useState({});
const [visibleCards, setVisibleCards] = useState(5);

  // 🔹 Fetch selected Home Page Categories
  const getSelectedHomeCategory = async () => {
    try {
      const res = await axios.get(`/api/homecategory/get-home-category`);
      setPopularDestination(res.data.data[0]?.popularCategory || []);
    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 Fetch all categories
  const getAllCategory = async () => {
    try {
      const res = await axios.get(`/api/category/get-all-category`);
      setAllCategory(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 Fetch all trips
  const getAllTrips = async () => {
    try {
      const res = await axios.get(`/api/trips/get-all-trips`);
      setAllTrips(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 Compute stats (total trips + lowest price) for each category
  useEffect(() => {
    if (!allTrips.length || !popularDestination.length) return;

    const stats = {};

    popularDestination.forEach((categoryName) => {
      const filteredTrips = allTrips.filter((trip) =>
        trip.category?.some((cat) =>
          cat.toLowerCase().includes(categoryName.toLowerCase())
        )
      );

      let lowestPrice = Infinity;

      filteredTrips.forEach((trip) => {
        trip.costing
          ?.filter(
            (costBlock) =>
              costBlock.heading &&
              costBlock.heading.toLowerCase().includes("group departure")
          )
          ?.forEach((costBlock) => {
            costBlock.package?.forEach((pkg) => {
              const price = Number(pkg.price);
              if (!isNaN(price) && price > 0 && price < lowestPrice) {
                lowestPrice = price;
              }
            });
          });
      });

      stats[categoryName] = {
        totalTrips: filteredTrips.length,
        lowestPrice: isFinite(lowestPrice) ? lowestPrice : 0,
      };
    });

    setCategoryStats(stats);
  }, [allTrips, popularDestination]);
  // 🔹 Handle visible cards on resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setVisibleCards(4); // Show 6 cards on mobile
      } else {
        setVisibleCards(5); // Show 5 cards on desktop
      }
    };

    handleResize(); // Run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🔹 Initial Data Fetch
  useEffect(() => {
    getSelectedHomeCategory();
    getAllCategory();
    getAllTrips();
  }, []);

  return (
    <div className="Mon_font customised-container d-block m-auto text-center">
<Link to="/customise-trip" className="text-decoration-none text-dark">
      <h2 className="fw-bolder m-0">Customize Your Trip</h2>
    </Link>      <div className="hr-line mb-3"></div>
      <p>Your Dates + Your Group + Your Budget</p>

      <div className="customised-trips-container">
{popularDestination.slice(0, visibleCards).map((item) => {
          const category = allCategory.find(
            (obj) =>
              obj.name.trim().toLowerCase() === item.trim().toLowerCase()
          );

          const stats = categoryStats[item] || {};
          const packageCount = stats.totalTrips || 0;
          const startingPrice = stats.lowestPrice || 0;

          return (
           <div
  key={item}
  onClick={() => navigate(`/category/${item}`)}
  className="customised-trips"
>
  <img
    src={category?.url}
    alt={item}
    className="customised-trips-img"
  />

              <div className="bckd">
                <h4>{item}</h4>
                <div className="package-info">
                  <p className="package-count">{packageCount}+ Packages</p>
                  <p className="starting-price">
                    Starting from{" "}
                    <span>₹{startingPrice.toLocaleString()}</span>
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PopularDestination;
